<app-loading *ngIf="contentReady"></app-loading>

<div class="bg-light" style="margin-bottom: 80px;">
    <div class="container" style="margin-top: 20px;">
        <div class="row justify-content-center">


            <div class="row" style="padding: 0;">
                <div class="col-6">
                    <h4> {{"Search Results"| transloco }}</h4>
                </div>
                <div class="col-6 text-align" style="margin-top: 5px;">
                    <p>{{stockTotal}} {{"Product"| transloco }}</p>
                </div>

                <app-product *ngFor="let element of allData" class="col-6 col-md-4 pointer" [element]="element"
                    [isAr]="isAr"></app-product>
            </div>






        </div>
    </div>
</div>